import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: theme.spacing(2),
  },
  inputRow: {
    margin: theme.spacing(1, 0),
  },
}));

export default useStyles;
